// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"v2-z","subtitle":"w2-z","wrapper":"x2-z","leftArrow":"y2-z","rightArrow":"z2-z"};